import { writable } from 'svelte/store';
import { isLargeScreen } from './helpers';
import { VOCABULARY } from './constants';

export const userLevelStore = writable('');
export const currentLevelsStore = writable('');
export const searchParamsStore = writable({
  types: [],
  text: '',
  srs: [],
  partsOfSpeech: [],
  percentageCorrectThreshold: 100,
});
export const filterStateStore = writable({
  active: isLargeScreen(),
});
export const progressStore = writable();
export const sortStore = writable('recently started');
export const currentViewStore = writable(
  window.localStorage.getItem('userProgress') || VOCABULARY
);
export const flashCardModeStore = writable({
  active: false,
  randomizeOrder: false,
});
export const descriptionWindowStore = writable({
  active: false,
  characters: null,
  subjectType: null,
  meaning: null,
  meaningMnemonic: null,
  readingMnemonic: null,
});
